import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useTheme } from '../../DataStore/ThemeContext';
import { useConfig } from '../../DataStore/ConfigContext';
import ajaxConfig from '../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    username: '',
    role: '',
    loading: false,
}

const NewUserInvite = () => {

    const {setNotify, setSystemFunction} = useTheme();

    const [info, setInfo] = useState(null);
    const {getUserRoles, getUsers, userRoles} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getUserRoles();
    }, [])

    useEffect(() => {
        // setSystemFunction expects a FUNCTION, not the execution result
        setSystemFunction(() => handleSave);
        return () => {
          // reset the system function when this modal unmounts
          setSystemFunction(() => () => alert("No Function Assigned"));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [state]);

    const handleSave = async () =>{
        if(state.loading){
            return;
        }
        if(!state.username.trim()){
            setInfo(<Notification type='danger' message="Username or email is required"/>);
            return;
        }

        if(!state.role.value){
            setInfo(<Notification type='danger' message="Select user role, then try again"/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.inviteUser({'role_id':state.role.value, 'username': state.username});
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setInfo(<Notification type='success' message={server_response.message}/>);
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'RESET'});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            setTimeout(() => {
                getUsers(true);
            }, 2000);
           
        }else{
            setInfo(<Notification type='danger' message={server_response.message}/>);

        }

    }




    const RenderRole = () => {
        const options = [];
         Array.isArray(userRoles) && userRoles.map((item) =>
                options.push({ label: item.role_name, value: item.id })
            );
        

        return (
            <TextInput
                label="User Role"
                type="select"
                leftIcon="fa fa-user-group"
                placeholder={state.role.label || 'Select user role....'}
                options={options}
                onChange={(item) => dispatch({ type: 'role', value: item })}
                leftComponent={<i className="fa fa-user-group link" onClick={getUserRoles}></i>}
                loading={!userRoles}
                wrap
                value={state.role}
            />
        );
    };

    return (
        <>
            <div className="mb-4">

            <CallOut 
                    title="Getting Started"
                    icon="fa-regular fa-lightbulb"
                    description={
                        <ul className="mb-0 pl-3" style={{ fontSize: '13px', lineHeight: '1.6' }}>
                            <li>Enter an existing user by <strong>Email</strong> or <strong>Username</strong>.</li>
                            <li>Assign a <strong>Role</strong> to define what they can see and do.</li>
                            <li>Users are active immediately upon invitation.</li>
                        </ul>
                    }
                />
            </div>
            {info}
            <form className="form-horizontal" method="post">

                        <TextInput
                            type="text"
                            label="Username or Email"
                            placeholder="Username or Email"
                            leftIcon="fa fa-envelope"
                            value={state.username}
                            onChange={e => dispatch({type: 'username', value: e.target.value})}
                            required
                            wrap
                            />

                            <RenderRole />

                    
                        </form> 

        </>
    );
};

export default NewUserInvite;